<template>
  <div>
    <empty-state
      v-if="loading || !data || Object.keys(data).length === 0"
      :loading="loading"
      :title="loading ? $t('loading') : $t('no_data_available')"
      :subtitle="!loading ? $t('no_orders_found') : ''"
      icon="mdi-cart"
    />
    <div v-else>
      <template v-for="(dateData, date) in data">
        <report-table-summary-bar
          :date="date"
          :date-data="dateData"
          :currency="restaurantCurrency"
        />

        <!-- Mobile View -->
        <template v-if="device.isMobile">
          <report-guest-order-card-mobile
            v-for="(item, index) in searchedItems(dateData)"
            :key="`mobile-${date}-${index}`"
            :item="item"
            :currency="restaurantCurrency"
            :changing-status-order-id="changingStatusOrderId"
            @show-user-details="showUserDetails"
            @show-restaurant-details="showRestaurantDetails"
            @change-status="$emit('change-status', $event)"
            @show-details="$emit('show-details', $event)"
          />
        </template>

        <!-- Desktop View -->
        <report-guest-order-table-desktop
          v-else
          :key="`table-${date}`"
          :items="searchedItems(dateData)"
          :loading="loading"
          :currency="restaurantCurrency"
          :changing-status-order-id="changingStatusOrderId"
          @show-user-details="showUserDetails"
          @show-restaurant-details="showRestaurantDetails"
          @change-status="$emit('change-status', $event)"
          @show-details="$emit('show-details', $event)"
        />
      </template>
    </div>

    <!-- Restaurant Details Dialog -->
    <restaurant-details-dialog
      v-model="restaurantDetailsDialog"
      :restaurant="selectedRestaurant"
    />

    <!-- User Details Dialog -->
    <guest-user-details-dialog v-model="userDetailsDialog" :user="selectedUser" />
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";
import RestaurantDetailsDialog from "@/components/dialogs/RestaurantDetailsDialog.vue";
import GuestUserDetailsDialog from "@/components/dialogs/GuestUserDetailsDialog.vue";
import ReportTableSummaryBar from "@/components/guest/ReportTableSummaryBar.vue";
import ReportGuestOrderCardMobile from "@/components/guest/ReportGuestOrderCardMobile.vue";
import ReportGuestOrderTableDesktop from "@/components/guest/ReportGuestOrderTableDesktop.vue";

export default {
  name: "ReportTable",
  components: {
    EmptyState,
    RestaurantDetailsDialog,
    GuestUserDetailsDialog,
    ReportTableSummaryBar,
    ReportGuestOrderCardMobile,
    ReportGuestOrderTableDesktop,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
    changingStatusOrderId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      restaurantDetailsDialog: false,
      selectedRestaurant: null,
      userDetailsDialog: false,
      selectedUser: null,
    };
  },
  methods: {
    searchedItems(dateData) {
      return this.customSearch(dateData, [], this.searchQuery, [
        "name",
        "lastname",
        "phone",
        "email",
        "orders_guest",
      ]);
    },
    showRestaurantDetails(restaurant) {
      this.selectedRestaurant = restaurant;
      this.restaurantDetailsDialog = true;
    },
    showUserDetails(user) {
      this.selectedUser = user;
      this.userDetailsDialog = true;
    },
  },
};
</script>
